import Checkbox from '@cobliteam/ui/form/Checkbox';
import Label from '@cobliteam/ui/form/Label';

import type { SafetyOccurrence } from '@cobliteam/common-types';

interface SafetyOccurrenceTitleProps {
  checked: boolean;
  data: SafetyOccurrence;
  onChange: () => void;
}

const SafetyOccurrenceTitle = ({ checked, onChange, data }: SafetyOccurrenceTitleProps) => {
  const { id, name } = data;

  return (
    <div className='ml-5 flex items-center gap-2'>
      <Checkbox key={`${id}-safety-occurrence-item`} id={`${id}-safety-occurrence-item`} checked={checked} onCheckedChange={onChange} />
      <Label htmlFor={`${id}-safety-occurrence-item`}>{name}</Label>
    </div>
  );
};
export default SafetyOccurrenceTitle;
